import { bindActionCreators } from 'redux';
import { mapValues, partial } from 'lodash';

const bindActionCreatorsWithArgs = (actions, dispatch, ...args) =>
  bindActionCreators(
    mapValues(actions, action => partial(action, ...args)),
    dispatch
  );
export default bindActionCreatorsWithArgs;
